import { Component, HostListener, input, model, output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal.html',
  styleUrl: './modal.css',
})
export class Modal {
  readonly isOpen = model<boolean>(false);
  readonly title = input<string>('Modal Title');
  readonly closable = input<boolean>(true);
  readonly close = output<void>();

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.isOpen() && this.closable()) {
      this.onClose();
    }
  }

  onClose(): void {
    if (this.closable()) {
      this.isOpen.set(false);
      this.close.emit();
    }
  }
}
